export const ListQueryKey = 'adminlist';
export const DetailQueryKey = 'admin';

export const Urls = {
  selectUrl: '/admin/list',
  updateUrl: '/admin/update',
  deleteUrl: '/admin/delete',
  createUrl: '/admin/create',
  detailUrl: '/admin/detail',
};
